import { render } from "./Realdata.vue?vue&type=template&id=88300aa8"
import script from "./Realdata.vue?vue&type=script&lang=js"
export * from "./Realdata.vue?vue&type=script&lang=js"

import "./Realdata.vue?vue&type=style&index=0&id=88300aa8&lang=scss"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__